export const blogTipData = {
    "status": 200, "desc": "OK", "data": {
        "entries": [{
            "id": 304124,
            "title": "트래픽 폭락 사태의 원인  'AI알고리즘 업데이트'",
            "viewCount": 116,
            "commentCount": 7,
            "registered": "2024.06.08 16:55",
            "summary": "최근 구글 알고리즘에 AI가 탑재되고 전세계 웹사이트 대부분 -80% 트래픽 소실을 겪고 있습니다. 여기서 한 가지 짚고 넘어가야할 것이 AI 검색이랑 AI 알고리즘 차이점 입니다. AI검색은 GPT, CoPilot, Gemini처럼 챗봇 기능으로 정보를 찾는 기능이고, 미국에서는 구글 검색시 상단에 AI가 정보를 요약해 제공 중이며 하단에 일반적인 검색 결과가 따라옵니다. 네이버도 마찬가지로 cue도 신청자 대상으로 질문형 검색어 입력시 AI가 요약해",
            "content": "최근 구글 알고리즘에 AI가 탑재되고 전세계 웹사이트 대부분 -80% 트래픽 소실을 겪고 있습니다. \r\n\r\n여기서 한 가지 짚고 넘어가야할 것이 AI 검색이랑 AI 알고리즘 차이점 입니다. \r\n\r\nAI검색은 GPT, CoPilot, Gemini처럼 챗봇 기능으로 정보를 찾는 기능이고, 미국에서는 구글 검색시 상단에 AI가 정보를 요약해 제공 중이며 하단에 일반적인 검색 결과가 따라옵니다. 네이버도 마찬가지로 cue도 신청자 대상으로 질문형 검색어 입력시 AI가 요약해 제공 후 아래 부분에 일반적인 검색 결과가 나옵니다.\r\n\r\nAI알고리즘은 구글 알고리즘에 AI가 추가된 것입니다. 최근 웹사이트 대부분이 -80%트래픽 감소를 겪고 있는데  알고리즘 자체에 ai가 들어있어 검색 의도를 파악하고, 컨텐츠 내용과 구성까지 파악해 검색결과를 제공합니다. 이게 무슨 말이냐면 예전에 키워드로 검색순위를 노리던 시절은 옛날 이야기가 되었다는 것입니다. \r\n\r\nLLM(언어처리모델)을 통해 검색 의도에 정확히 맞는 결과값만 나오기 때문에 그동안 키워드로 세팅된 검색순위가 폭락했죠. 타겟 키워드 잡고 작성된 컨텐츠는 대부분 뒤로 밀렸을 것입니다. (중요한건 이 방식이 전통 SEO 기본이라 대부분 페이지가 걸림. + 블로그 포함 Publisher 타겟 검색 순위 강등 조치, AI 출처 확보 시 신뢰성 이슈로 개인매체 저평가)\r\n\r\n전 세계적인 현상이며 지금 이 상황은 전통적인 검색엔진최적화(SEO) 기술이 더 이상 통하지 않다는 점을 시사합니다. \r\nhttps://www.bbc.com/korean/articles/c166p510n79o\r\n\r\n작년 10월부터 계단식으로 트래픽이 빠지고 있는데요, 알고리즘 작동 원리 자체가 변경된 것이기 때문에 테크니컬 SEO도 예전만큼 효과를 거두기 어려운 현실입니다. 현재 최선은 일단 상황을 지켜보는 것이네요. ",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 1185164,
            "userName": "브랜던의 지식공장",
            "userDefaultUrl": "https://infiniteinformation.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2824660/attach/44523e9670224dafb46a227283f083fd",
            "status": "normal"
        }, {
            "id": 304026,
            "title": "AI 검색이라는 환각에 빠져서 실제를 못보는 것도 ",
            "viewCount": 27,
            "commentCount": 4,
            "registered": "2024.06.07 16:22",
            "summary": "어떻게 보면 인간 오류죠.",
            "content": "어떻게 보면 인간 오류죠. ",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 86533,
            "userName": "티스토리탈출",
            "userDefaultUrl": "https://exit-out.tistory.com",
            "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
            "status": "normal"
        }, {
            "id": 304012,
            "title": "티스토리 항상 떠있는 링크버튼에 효과입히기",
            "viewCount": 38,
            "commentCount": 1,
            "registered": "2024.06.07 13:03",
            "summary": "항상 떠있는 버튼으로 애드센스의 수익을 더욱 높여보세요. 버튼을 방문자가 더욱 잘 인식할 수 있는 테두리색상을 적용했으니까 살펴보고 맘에 드시면 블로그에 적용해볼 수 있어요. 아래의 주소에 가시면 어떤 버튼인지 확인가능합니다. https://commagun.tistory.com/2110",
            "content": "항상 떠있는 버튼으로 애드센스의 수익을 더욱 높여보세요.\r\n버튼을 방문자가 더욱 잘 인식할 수 있는 테두리색상을 적용했으니까\r\n살펴보고 맘에 드시면 블로그에 적용해볼 수 있어요.\r\n아래의 주소에 가시면 어떤 버튼인지 확인가능합니다.\r\nhttps://commagun.tistory.com/2110",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 561619,
            "userName": "콤마군",
            "userDefaultUrl": "https://commagun.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/714726/attach/5a31e532185d49c49dda273e1ea30894",
            "status": "normal"
        }, {
            "id": 304009,
            "title": "AI 검색 Gemini 놀라울 정도로 정확해지네요",
            "viewCount": 92,
            "commentCount": 0,
            "registered": "2024.06.07 12:13",
            "summary": "AI검색이 부정확하고, 창작자들의 지적재산권을 침해한다고 주장하시며 ONLY 환각현상만 주장하시는 세컨ID(본캐확인)가 있습니다. 오늘 Gemini로 한국 영화 역대 흥행을 물어봤는데 놀랍네요. 한국영화 역대 흥행 5위, 6위가 어벤저스 엔드게임, 아바타인데 이 점까지 놓치지 않고 '5위와 6위는 외국 영화이지만, 한국에서 매우 흥행하여 포함했습니다.'라고 밝혀줍니다. Gemini 결과 : https://g.co/gemini/share/78c7e92aa",
            "content": "AI검색이 부정확하고, 창작자들의 지적재산권을 침해한다고 주장하시며 ONLY 환각현상만 주장하시는 세컨ID(본캐확인)가 있습니다.\r\n\r\n오늘 Gemini로 한국 영화 역대 흥행을 물어봤는데 놀랍네요. 한국영화 역대 흥행 5위, 6위가 어벤저스 엔드게임, 아바타인데 이 점까지 놓치지 않고 '5위와 6위는 외국 영화이지만, 한국에서 매우 흥행하여 포함했습니다.'라고 밝혀줍니다. \r\n\r\nGemini 결과 : https://g.co/gemini/share/78c7e92aa49a\r\n(Gemini 무료와 유료버전 간 결과값 차이로 보면 유료에 리소스를 더 투입하는 듯)\r\n\r\n현재 미국에서 Google로 검색 시 AI 검색결과 동시 표기하고 있습니다. 3.3억 미국 인구가 세계에서 가장 많은 정보를 가진 영어로 검색하고 있다보니 데이터가 정확해지는 것으로 보이며, 인구 1/6인 한국에 런칭 시 여기서 쌓은 데이터로 한국어도 빠른 시간 내로 정확도를 갖출 것으로 보입니다. \r\n\r\n정확도를 위해 블로거 등 개인 publisher는 데이터에서 열외시키는 것으로 보이며, 포맷 상관 없이 공식 출처 데이터 위주로 수집하는 것으로 보입니다. 이제까지  '공식 출처 내용 ->블로거가 편집 -> 검색노출'이었다면 AI가 도입됨으로써 '블로거가 편집' 부분이 '(AI가 공식 출처 위주로) 편집'으로 변화한 것입니다. \r\n\r\n예: '버스 시간표->(블로거)가 버스회사 시간표 확인 후 작성 -> 검색결과'에서 '(AI)가 공인 출처위주로 찾아 취합 후 결과 전달\r\n\r\n한마디로 블로거가 하던 일을 AI가 대체한다는 소리고 앞으로는 광고 포맷도 AI검색 결과에 맞게 AI가 생성하는 초 타겟형 광고로 바뀔 가능성이 높습니다. (실제로 글로벌 광고업계 AI 전문가 채용 중) \r\nhttps://economist.co.kr/article/view/ecn202305030019\r\n앞으로는 정보성 블로그는 점진적으로 AI 검색결과로 대체되고, 개인적인 메세지 중심 매체로 바뀔 듯 합니다. (IG사진,BG블로",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 1185164,
            "userName": "브랜던의 지식공장",
            "userDefaultUrl": "https://infiniteinformation.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2824660/attach/44523e9670224dafb46a227283f083fd",
            "status": "normal"
        }, {
            "id": 303858,
            "title": "대체적으로 *** 망한다고 하는사람들은...",
            "viewCount": 76,
            "commentCount": 2,
            "registered": "2024.06.05 16:39",
            "summary": "해당 분야에서 하위권에 있는 사람들이 하는소리니 무시해도 됩니다. 어짜피 그사람들은 “나는 열심히 해도 안되니 너도 하지마” 라고 하는거라 무시하는게 좋습니다.",
            "content": "해당 분야에서 하위권에 있는 사람들이 하는소리니 무시해도 됩니다.\r\n어짜피 그사람들은 \"나는 열심히 해도 안되니 너도 하지마\" 라고 하는거라 무시하는게 좋습니다.\r\n",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 6657092,
            "userName": "ゼン",
            "userDefaultUrl": "https://zenn-dev.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/7043250/attach/0c36ddbc02b54b29a726fd34ee17fb19",
            "status": "normal"
        }, {
            "id": 303856,
            "title": "블로그가 끝났다 뭐 영상이 대세다 그렇기는 하지만",
            "viewCount": 58,
            "commentCount": 2,
            "registered": "2024.06.05 16:19",
            "summary": "저는 아직까지 블로그 보는 사람들은 본다고 생각합니다. 또한, 신문기사도 디지털 시대에 인터넷 기사가 나오고 망한다고 했는데 아직까지 유지되고 있습니다. 비록 수요는 줄어들겠지만, 꾸준히 계속 한다면 또 다른 기회가 생길 것이라 생각합니다.",
            "content": "저는 아직까지 블로그 보는 사람들은 본다고 생각합니다.\r\n또한, 신문기사도 디지털 시대에 인터넷 기사가 나오고 망한다고 했는데 아직까지 유지되고 있습니다.\r\n비록 수요는 줄어들겠지만, 꾸준히 계속 한다면 또 다른 기회가 생길 것이라 생각합니다.",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 6162360,
            "userName": "Edward_S",
            "userDefaultUrl": "https://news8253.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6306155/attach/b6417ec3e9be4cd6ac34b6c1964077b3",
            "status": "normal"
        }, {
            "id": 303855,
            "title": "블로그 수익은 월초 포스팅에 따라 결정됩니다. ",
            "viewCount": 36,
            "commentCount": 0,
            "registered": "2024.06.05 16:06",
            "summary": "월초에 광고비를 많이 지출하기 때문에 블로그 수익은 월초에 포스팅을 많이 할수록 좋습니다. https://hola0829.tistory.com/entry/%ED%8B%B0%EC%8A%A4%ED%86%A0%EB%A6%AC-%EC%95%A0%EB%93%9C%EC%84%BC%EC%8A%A4-%EC%82%AC%EC%9D%B4%EB%93%9C%EB%B0%94-%EA%B4%91%EA%B3%A0-%EC%84%A4%EC%B9%98-%EB%B0%A9%EB%B2%95-%",
            "content": "월초에 광고비를 많이 지출하기 때문에 블로그 수익은 월초에 포스팅을 많이 할수록 좋습니다. https://hola0829.tistory.com/entry/%ED%8B%B0%EC%8A%A4%ED%86%A0%EB%A6%AC-%EC%95%A0%EB%93%9C%EC%84%BC%EC%8A%A4-%EC%82%AC%EC%9D%B4%EB%93%9C%EB%B0%94-%EA%B4%91%EA%B3%A0-%EC%84%A4%EC%B9%98-%EB%B0%A9%EB%B2%95-%EA%B4%91%EA%B3%A0-%EC%84%A4%EC%A0%95-%EA%B4%91%EA%B3%A0-%EC%88%98%EC%9D%B5-%EA%BF%80%ED%8C%81",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 1231432,
            "userName": "여마로드",
            "userDefaultUrl": "https://hola0829.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/1648332/attach/f0a95fde97794121806a8cea7ebfdb06",
            "status": "normal"
        }, {
            "id": 303718,
            "title": "블로그는 끝난게 맞는 것 같습니다",
            "viewCount": 338,
            "commentCount": 17,
            "registered": "2024.06.04 12:11",
            "summary": "사람들이 글이 아닌 짧은 쇼츠 영상으로 정보를 얻는 시대로 바뀌었습니다. 블로그를 하든 뭘 하든 결국 목적은 수익인데 인스타그램 릴스 수익화 얼마씩 나오는지 아세요? 틱톡 라이트 얼마씩 주는지 아세요? 인스타그램 릴스와 틱톡이 서로 경쟁하며 사용자들에게 돈을 퍼주면서 점유율을 올리려고 경쟁하고 있습니다. 이쪽은 흔히 말해 아직 일한 만큼 받는 영역입니다. 초기 단계라서 아직은요. 물론 조회수가 많이 나와야 돈을 주긴 하죠. 물론 틱톡 성격상 개인 정보를",
            "content": "사람들이 글이 아닌 짧은 쇼츠 영상으로 정보를 얻는 시대로 바뀌었습니다.\r\n\r\n블로그를 하든 뭘 하든 결국 목적은 수익인데\r\n인스타그램 릴스 수익화 얼마씩 나오는지 아세요?\r\n틱톡 라이트 얼마씩 주는지 아세요?\r\n\r\n인스타그램 릴스와 틱톡이 서로 경쟁하며 사용자들에게 돈을 퍼주면서 점유율을 올리려고 경쟁하고 있습니다. 이쪽은 흔히 말해 아직 일한 만큼 받는 영역입니다. 초기 단계라서 아직은요. \r\n\r\n물론 조회수가 많이 나와야 돈을 주긴 하죠.\r\n물론 틱톡 성격상 개인 정보를 중국 정부에 다 털려야 돈을 주긴 하죠.\r\n\r\n시대가 변했습니다. 글로 정보를 얻는 시대가 아니라 짧은 영상으로 정보를 얻는 시대가 되었습니다.\r\n아직 글로만 정보를 얻을 수 있는 영역이 있겠지만 과연 뭐가 있을까요?\r\n\r\n다시 글로 정보를 얻는 시대가 올까요? 오긴 올 수야 있겠죠. 다른 형태로 변해서 오겠지만.\r\n\r\n블로그를 하는 이유가 \r\n1. 자신의 회사, 브랜드를 홍보하거나\r\n2. 영상으로 할 수 있는 컨텐츠가 없다거나 \r\n3. 부업으로 본업 외에 나를 덜 노출시키며 수익을 얻을 수 있는 창구를 찾아서 하게되는건데\r\n\r\n저도 애드센스 100달러만 채우고 블로그 접으렵니다.\r\n제 관심사에 대한 관심을 유지하려고 계속 할 고민을 하고 있는데 아무래도 안될 것 같네요",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 5029425,
            "userName": "패트릭　",
            "userDefaultUrl": "https://trikkypat.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4898063/attach/3088ef62e7ca4a2eb3ad3125c533028b",
            "status": "normal"
        }, {
            "id": 303714,
            "title": "방문자 수가 많다고 수익이 많은 것은 아니네요. ",
            "viewCount": 68,
            "commentCount": 4,
            "registered": "2024.06.04 11:41",
            "summary": "방문자 수가 많다고 수익과 바로 연결되지는 않네요. 방문자가 가장 많은 날보다 거의 절반 수준의 방문자일 때 수익이 3배 이상 많은 적도 있었어요. 클릭 수도 비슷한데, 결국은 광고의 단가 때문일까요? 의견 남겨주세요~!",
            "content": "방문자 수가 많다고 수익과 바로 연결되지는 않네요. 방문자가 가장 많은 날보다 거의 절반 수준의 방문자일 때 수익이 3배 이상 많은 적도 있었어요. \r\n\r\n클릭 수도 비슷한데, 결국은 광고의 단가 때문일까요?\r\n의견 남겨주세요~! ",
            "category": "블로그 운영팁",
            "images": [],
            "userId": 4722890,
            "userName": "아이맘",
            "userDefaultUrl": "https://imom1016.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4435635/attach/b4c71c89065e4fdb9e316be6b4a71c2a",
            "status": "normal"
        }, {
            "id": 303567,
            "title": "키워드의 중요성...",
            "viewCount": 49,
            "commentCount": 0,
            "registered": "2024.06.03 10:41",
            "summary": "진짜 키워드가 중요하다는 건 무시했었는데... 키워드 하나 잘 잡아서 썻더니 일 방문자가 250명.................",
            "content": "진짜 키워드가 중요하다는 건 무시했었는데...\r\n키워드 하나 잘 잡아서 썻더니 일 방문자가 250명.................",
            "category": "블로그 운영팁",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/a2fa9e3c-3922-4ff1-b70e-05c0d17a0f5d",
                "size": 34654,
                "label": "캡처처.PNG"
            }],
            "userId": 5703388,
            "userName": "건행 라이프",
            "userDefaultUrl": "https://ohhealthylife.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6683921/attach/3d36bf880ca84b42b20484d44cf236a6",
            "status": "normal"
        }], "hasPrev": true, "hasNext": false
    }
};
export const blogEtcData = {
    "status": 200, "desc": "OK", "data": {
        "entries": [{
            "id": 304153,
            "title": "고수님들 질문하나에 답변부탁드립니다.",
            "viewCount": 24,
            "commentCount": 1,
            "registered": "2024.06.08 22:17",
            "summary": "저는 말그대로 이제 블로그 시작한지 1달 반 되어가는데요. 다른 분들은 다음 최적화가 되면 사이트가 다음에서 검색되면서 유입이 는다고 들었는데, 저는 왜 딱히 늘지 않을까요? 글은 열심히 작성하는데, 유입이 도대체가 안 늘어나니깐 솔직히 조금 이게 뭔가 싶네요. 유튜브에서 알려주는 기초 세팅? 이런거 보면서 내가 달랐던 부분들은 조금씩 수정하면서 하는데, 왜 유입이 안되는지 혹시 알려주실 고수님들 안 계실까요?",
            "content": "저는 말그대로 이제 블로그 시작한지 1달 반 되어가는데요.\r\n\r\n다른 분들은 다음 최적화가 되면 사이트가 다음에서 검색되면서 유입이 는다고 들었는데,\r\n\r\n저는 왜 딱히 늘지 않을까요?\r\n\r\n글은 열심히 작성하는데, 유입이 도대체가 안 늘어나니깐 솔직히 조금 이게 뭔가 싶네요.\r\n\r\n유튜브에서 알려주는 기초 세팅? 이런거 보면서 내가 달랐던 부분들은 조금씩 수정하면서 하는데, \r\n\r\n왜 유입이 안되는지 혹시 알려주실 고수님들 안 계실까요?",
            "category": "질문/기타",
            "images": [],
            "userId": 6655080,
            "userName": "Supe-ND",
            "userDefaultUrl": "https://healthy-welllife.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/7040189/attach/f33fb41fadaa44a9b23e3126df093ea9",
            "status": "normal"
        }, {
            "id": 304115,
            "title": "방문자수 급락 ㅠ 원인이 뭘까요? (feat.구글오래된",
            "viewCount": 107,
            "commentCount": 5,
            "registered": "2024.06.08 14:33",
            "summary": "구글 검색 유입으로 먹고 사는(?) 블로그였는데요.. 최근들어 너무 급감했는데요 유입이.. 포스팅을 1일 1포는 못해도 꾸준히는 유지하고 있는데..이상헙니다. 특별히 그전에도 광고를 한다거나 뭐 방문객을 끌어모으기 위해 했던 방법은 딱히 없거든요..? 구글 서치콘솔봐도 유입이 감소한건 알겠지만.. 구글도 혹시 포스팅한지 오래된 글(오랫동안 검색 시 1-2순위 위치에 보이던 상위노출 글들?)은 일정 시기가 지나면 뒤로 밀리거나 그런가요? ㅠㅠ",
            "content": "구글 검색 유입으로 먹고 사는(?) 블로그였는데요.. 최근들어 너무 급감했는데요 유입이..\r\n포스팅을 1일 1포는 못해도 꾸준히는 유지하고 있는데..이상헙니다.\r\n특별히 그전에도 광고를 한다거나 뭐 방문객을 끌어모으기 위해 했던 방법은 딱히 없거든요..? \r\n\r\n구글 서치콘솔봐도 유입이 감소한건 알겠지만..\r\n구글도 혹시 포스팅한지 오래된 글(오랫동안 검색 시 1-2순위 위치에 보이던 상위노출 글들?)은\r\n일정 시기가 지나면 뒤로 밀리거나 그런가요? ㅠㅠ",
            "category": "질문/기타",
            "images": [],
            "userId": 4732953,
            "userName": "허니바이브",
            "userDefaultUrl": "https://euphoria25.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4449721/attach/c3938d08707b4146a2414363390bfbe6",
            "status": "normal"
        }, {
            "id": 304100,
            "title": "AI 검색 사랑해요.",
            "viewCount": 16,
            "commentCount": 1,
            "registered": "2024.06.08 10:49",
            "summary": "AI 검색 사랑해요. AI 검색 비중이 높아진다는 것은 블로그 검색 비중이 낮아지는 거 아닌가요? 물론 블로그로 검색해서 그 글을 확인하는 경우도 있겠지만, AI 검색을 하였을 때 예를 들어 카메라 사진 작례라든가... AI가 출처를 확인하여 해당하는 블로그만 엄선해서 보여준다던가... 아니면 그 사진들만 뽑아서 보여준다던가 하지 않을까요? 틀린 정보 있을 수 있습니다. 단 나아질 거라고 봅니다.",
            "content": "AI 검색 사랑해요.\r\nAI 검색 비중이 높아진다는 것은 블로그 검색 비중이 낮아지는 거 아닌가요?\r\n물론 블로그로 검색해서 그 글을 확인하는 경우도 있겠지만, AI 검색을 하였을 때 예를 들어 카메라 사진 작례라든가... AI가 출처를 확인하여 해당하는 블로그만 엄선해서 보여준다던가... 아니면 그 사진들만 뽑아서 보여준다던가 하지 않을까요?\r\n\r\n틀린 정보 있을 수 있습니다. 단 나아질 거라고 봅니다.",
            "category": "질문/기타",
            "images": [],
            "userId": 1079898,
            "userName": "센고쿠",
            "userDefaultUrl": "https://ashitaka21.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2854468/attach/556a2f27262a45669ffe7a7697fe9e9f",
            "status": "normal"
        }, {
            "id": 304097,
            "title": "구독자가 2명 늘었습니다. 감사는 한데...",
            "viewCount": 16,
            "commentCount": 1,
            "registered": "2024.06.08 10:41",
            "summary": "구독자가 2명 늘었습니다. 감사는 한데... 구독중 7, 구독자 536에서 538이 되었습니다. 왜 구독하셨을까요? 볼 것도 없을 텐데...",
            "content": "구독자가 2명 늘었습니다. 감사는 한데...\r\n구독중 7, 구독자 536에서 538이 되었습니다.\r\n\r\n왜 구독하셨을까요? 볼 것도 없을 텐데...",
            "category": "질문/기타",
            "images": [],
            "userId": 1079898,
            "userName": "센고쿠",
            "userDefaultUrl": "https://ashitaka21.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2854468/attach/556a2f27262a45669ffe7a7697fe9e9f",
            "status": "normal"
        }, {
            "id": 304002,
            "title": "자동으로 월 천만 원 벌기? 그런 것에 속지 마세요.",
            "viewCount": 41,
            "commentCount": 2,
            "registered": "2024.06.07 10:49",
            "summary": "자동으로 월 천만 원 벌기? 그런 것에 속지 마세요. 노력 없이 얻어지는 것은 없습니다. 자동으로 되는 것은 나이 먹는 것밖에는 없어요.",
            "content": "자동으로 월 천만 원 벌기? 그런 것에 속지 마세요.\r\n노력 없이 얻어지는 것은 없습니다.\r\n\r\n자동으로 되는 것은 나이 먹는 것밖에는 없어요.",
            "category": "질문/기타",
            "images": [],
            "userId": 1079898,
            "userName": "센고쿠",
            "userDefaultUrl": "https://ashitaka21.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2854468/attach/556a2f27262a45669ffe7a7697fe9e9f",
            "status": "normal"
        }, {
            "id": 304001,
            "title": "블로그 수입으로 편의점 커피는커녕 껌도 못 삽니다.",
            "viewCount": 180,
            "commentCount": 6,
            "registered": "2024.06.07 10:47",
            "summary": "블로그 수입으로 편의점 커피는커녕 껌도 못 삽니다. https://ashitaka21.tistory.com/220 솔직히 CPM 아니었으면 이번에도 수입은 없었을 겁니다. 애초에 클릭으로 먹고사는 블로그가 아니라서... 하지만 이 수입으로 커피는 커녕 껌도 못 사지요.",
            "content": "블로그 수입으로 편의점 커피는커녕 껌도 못 삽니다.\r\n\r\nhttps://ashitaka21.tistory.com/220\r\n\r\n솔직히 CPM 아니었으면 이번에도 수입은 없었을 겁니다.\r\n애초에 클릭으로 먹고사는 블로그가 아니라서... 하지만 이 수입으로 커피는 커녕 껌도 못 사지요.",
            "category": "질문/기타",
            "images": [],
            "userId": 1079898,
            "userName": "센고쿠",
            "userDefaultUrl": "https://ashitaka21.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2854468/attach/556a2f27262a45669ffe7a7697fe9e9f",
            "status": "normal"
        }, {
            "id": 303955,
            "title": "URL을 숫자에서 문자로바꾸면?",
            "viewCount": 14,
            "commentCount": 1,
            "registered": "2024.06.06 19:05",
            "summary": "이전에 숫자였던 URL은 문자주소로 변경되는 걸로 알고있는데... 숫자일때 URL링크 걸어뒀던건 자동 변경되나요 아님 링크 주소를 바뀐 문자주소로 다 변경해야하나요?",
            "content": "이전에 숫자였던 URL은 문자주소로 변경되는 걸로 알고있는데...\r\n숫자일때 URL링크 걸어뒀던건 자동 변경되나요 아님 링크 주소를 바뀐 문자주소로 다 변경해야하나요?",
            "category": "질문/기타",
            "images": [],
            "userId": 5173001,
            "userName": "N잡러의 느린생활",
            "userDefaultUrl": "https://stock-joorin2.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/5086101/attach/968db14b338c4f9e9109294ed8824c06",
            "status": "normal"
        }, {
            "id": 303948,
            "title": "인",
            "viewCount": 5,
            "commentCount": 0,
            "registered": "2024.06.06 17:42",
            "summary": "9a738d1f22004e7285ec2c24a3663453",
            "content": "9a738d1f22004e7285ec2c24a3663453",
            "category": "질문/기타",
            "images": [],
            "userId": 6681470,
            "userName": "아율아빵",
            "userDefaultUrl": "https://sasydear.tistory.com",
            "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
            "status": "normal"
        }, {
            "id": 303928,
            "title": "다음 유입이 확 줄었네요",
            "viewCount": 147,
            "commentCount": 2,
            "registered": "2024.06.06 14:21",
            "summary": "다음에 사이트 노출이 안되나 검색해봤으나 상단에 잘 노출되는걸 보면 저품질이 걸린건 아닌거같고 월간30 주간 6명인걸 보아하니 몇년전에 비해서 확연히 줄어들었네요. 대신에 줄어든 만큼 구글과 네이버의 유입이 무진장 증가하였는데 어떠한 유입 변화가 있는지 애널리틱스를 확인하여 분석하는 재미도 있을거 같네요. 구글애널리틱스에 블로그를 연동해놓으면 플랫폼,국가,검색어 별 통계치도 볼 수 있습니다.",
            "content": "다음에 사이트 노출이 안되나 검색해봤으나 상단에 잘 노출되는걸 보면 저품질이 걸린건 아닌거같고 월간30 주간 6명인걸 보아하니 몇년전에 비해서 확연히 줄어들었네요.\r\n\r\n대신에 줄어든 만큼 구글과 네이버의 유입이 무진장 증가하였는데 어떠한 유입 변화가 있는지 애널리틱스를 확인하여 분석하는 재미도 있을거 같네요. 구글애널리틱스에 블로그를 연동해놓으면 플랫폼,국가,검색어 별 통계치도 볼 수 있습니다. ",
            "category": "질문/기타",
            "images": [],
            "userId": 4493976,
            "userName": "최류현의 블로그",
            "userDefaultUrl": "https://newstroyblog.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4097354/attach/ddd5527cbf1b4238938b51811b6a1a9a",
            "status": "normal"
        }, {
            "id": 303917,
            "title": "댓글 잘 보고 갑니다 달렸을 때 답글 어떻게 달아요?",
            "viewCount": 89,
            "commentCount": 4,
            "registered": "2024.06.06 11:13",
            "summary": "댓글 잘 보고 갑니다 달렸을 때 답글 어떻게 달아요? https://ashitaka21.tistory.com/304 댓글이 현재 59개. 답글 포함하면 118개. 뭐 답글 다는 저도 압니다. 글 안 봤을 거라는 거. 그럼에도 제 답글은 좀 긴 편입니다. 그냥 본문 내용을 추가해서 답글 남기거나 하거든요. 여러분은 어떻게 다시나요?",
            "content": "댓글 잘 보고 갑니다 달렸을 때 답글 어떻게 달아요?\r\n\r\nhttps://ashitaka21.tistory.com/304\r\n\r\n댓글이 현재 59개. 답글 포함하면 118개.\r\n뭐 답글 다는 저도 압니다. 글 안 봤을 거라는 거. 그럼에도 제 답글은 좀 긴 편입니다.\r\n그냥 본문 내용을 추가해서 답글 남기거나 하거든요. \r\n\r\n여러분은 어떻게 다시나요?",
            "category": "질문/기타",
            "images": [],
            "userId": 1079898,
            "userName": "센고쿠",
            "userDefaultUrl": "https://ashitaka21.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2854468/attach/556a2f27262a45669ffe7a7697fe9e9f",
            "status": "normal"
        }], "hasPrev": true, "hasNext": false
    }
};
export const blogSkinData = {
    "status": 200, "desc": "OK", "data": {
        "entries": [{
            "id": 303764,
            "title": "오디세이 스킨 유튜브 공백 제거 좀 알려주세요~",
            "viewCount": 18,
            "commentCount": 1,
            "registered": "2024.06.04 18:38",
            "summary": "안녕하세요. 유튜브 동영상을 넣은 후, 영상을 좀 작게 조정하고 엔터를 누르면 어마무시한 공백이 생긴 후부터 글을 작성하더군요. 이 유튜브 넣은 이후 나오는 공백 제거법에 대해선 검색 많이 해봤는데 어디에도 제 스킨에 맞는 방법은 없었습니다. padding-bottom? 이런 것도 css에 없었군요.. 혹시 이 문제점을 해결하는 방법 아시는 분 계실까요?",
            "content": "안녕하세요.\r\n유튜브 동영상을 넣은 후, 영상을 좀 작게 조정하고 엔터를 누르면 어마무시한 공백이 생긴 후부터 글을 작성하더군요. 이 유튜브 넣은 이후 나오는 공백 제거법에 대해선 검색 많이 해봤는데 어디에도 제 스킨에 맞는 방법은 없었습니다. padding-bottom? 이런 것도 css에 없었군요.. 혹시 이 문제점을 해결하는 방법 아시는 분 계실까요?",
            "category": "스킨",
            "images": [],
            "userId": 6678254,
            "userName": "잡게왕",
            "userDefaultUrl": "https://leemkun.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/7077948/attach/3e682f4947b04184afbe358d5437ff8e",
            "status": "normal"
        }, {
            "id": 303740,
            "title": "블로그 망한다는데 괜찮을까요 ㅠㅠ",
            "viewCount": 25,
            "commentCount": 0,
            "registered": "2024.06.04 15:33",
            "summary": "블로그 망한다는데 괜찮을까요 ㅠㅠ",
            "content": "블로그 망한다는데 괜찮을까요 ㅠㅠ",
            "category": "스킨",
            "images": [],
            "userId": 6316796,
            "userName": "종합 블로그",
            "userDefaultUrl": "https://onlydice.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6517799/attach/ec0bcd538deb4c6bb97df48b72b21cbd",
            "status": "normal"
        }, {
            "id": 303169,
            "title": "내스킨 최적화 최고 쭉쭉간다",
            "viewCount": 27,
            "commentCount": 0,
            "registered": "2024.05.30 16:33",
            "summary": "ㄱㄱ",
            "content": "ㄱㄱ",
            "category": "스킨",
            "images": [],
            "userId": 6242730,
            "userName": "새로운 메시지",
            "userDefaultUrl": "https://newmessage.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6417033/attach/a10cbab17db643f7af70d381ecce41c5",
            "status": "normal"
        }, {
            "id": 303051,
            "title": "제스킨최적화 방문자폭주",
            "viewCount": 23,
            "commentCount": 0,
            "registered": "2024.05.29 15:46",
            "summary": "ㄱㄱㄱ",
            "content": "ㄱㄱㄱ",
            "category": "스킨",
            "images": [],
            "userId": 6242730,
            "userName": "새로운 메시지",
            "userDefaultUrl": "https://newmessage.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6417033/attach/a10cbab17db643f7af70d381ecce41c5",
            "status": "normal"
        }, {
            "id": 302105,
            "title": "티스토리블로그 스킨으로 모바일웹앱으로 구현가능?",
            "viewCount": 38,
            "commentCount": 0,
            "registered": "2024.05.21 16:38",
            "summary": "티스토리 블로그 스킨으로 모바일웹앱으로 구현 가능 합니다. 화면전환시 모바일앱 처럼 애니메이션 까지? 한번 테스트 영상으로 확인 해 보세요! https://blog.waanee.com/entry/%ED%8B%B0%EC%8A%A4%ED%86%A0%EB%A6%AC%EC%8A%A4%ED%82%A8%EC%9D%84-%EB%AA%A8%EB%B0%94%EC%9D%BC%EC%9B%B9%EC%95%B1%EC%9C%BC%EB%A1%9C-%EA%B0%80%EB%8A%A5",
            "content": "티스토리 블로그 스킨으로 모바일웹앱으로 구현 가능 합니다. 화면전환시 모바일앱 처럼 애니메이션 까지? \r\n한번 테스트 영상으로 확인 해 보세요! \r\n\r\nhttps://blog.waanee.com/entry/%ED%8B%B0%EC%8A%A4%ED%86%A0%EB%A6%AC%EC%8A%A4%ED%82%A8%EC%9D%84-%EB%AA%A8%EB%B0%94%EC%9D%BC%EC%9B%B9%EC%95%B1%EC%9C%BC%EB%A1%9C-%EA%B0%80%EB%8A%A5",
            "category": "스킨",
            "images": [],
            "userId": 1125025,
            "userName": "waaneeweb",
            "userDefaultUrl": "https://blog.waanee.com",
            "userImage": "https://t1.daumcdn.net/cfile/tistory/9946F53359832D632F",
            "status": "normal"
        }, {
            "id": 301005,
            "title": "다크모드/라이트모드에 따른 파비콘 변경 설정 방법",
            "viewCount": 38,
            "commentCount": 1,
            "registered": "2024.05.12 11:47",
            "summary": "다크모드/라이트모드에 따른 파비콘 변경 설정 방법을 작성해보았습니다. 놀러오셔서 많이 보고 가주세요~ https://happylie.tistory.com/200",
            "content": "다크모드/라이트모드에 따른 파비콘 변경 설정 방법을 작성해보았습니다.\r\n놀러오셔서 많이 보고 가주세요~\r\nhttps://happylie.tistory.com/200",
            "category": "스킨",
            "images": [],
            "userId": 588067,
            "userName": "선인장 \uD83C\uDF35",
            "userDefaultUrl": "https://happylie.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4921041/attach/d2daa345fff64282a6e51661274c4088",
            "status": "normal"
        }, {
            "id": 300930,
            "title": "칠절한효자손",
            "viewCount": 33,
            "commentCount": 1,
            "registered": "2024.05.11 13:48",
            "summary": "칠절한효자손",
            "content": "칠절한효자손",
            "category": "스킨",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/a7b75378-b82b-4004-ad1c-340110c8f35a",
                "size": 24704,
                "label": "08d55220c3614990b450f7ed5e046764.jpg"
            }],
            "userId": 6665205,
            "userName": "성준이1",
            "userDefaultUrl": "https://coolksg.tistory.com",
            "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
            "status": "normal"
        }, {
            "id": 300776,
            "title": "제작중인 블로그 스킨 배포를 시작했습니다.",
            "viewCount": 113,
            "commentCount": 0,
            "registered": "2024.05.10 00:01",
            "summary": "오늘부터 스킨을 배포하기 시작했습니다 새로운 스킨을 찾으시는 분이 있으시다면 작은 관심 부탁드리겠습니다 스킨 > 이용자 스킨 또는 블로그에서 확인 및 다운로드 가능합니다. 오류제보 및 건의사항도 환영합니다!",
            "content": "오늘부터 스킨을 배포하기 시작했습니다\r\n새로운 스킨을 찾으시는 분이 있으시다면 작은 관심 부탁드리겠습니다\r\n스킨 > 이용자 스킨 또는 블로그에서 확인 및 다운로드 가능합니다.\r\n오류제보 및 건의사항도 환영합니다!",
            "category": "스킨",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/cb2a323b-fd7d-494d-a3ef-2e83e9204da8",
                "size": 662197,
                "label": "preview1600.jpg"
            }],
            "userId": 6657092,
            "userName": "ゼン",
            "userDefaultUrl": "https://zenn-dev.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/7043250/attach/0c36ddbc02b54b29a726fd34ee17fb19",
            "status": "normal"
        }, {
            "id": 300234,
            "title": "스킨을 편집하고 싶습니다.",
            "viewCount": 61,
            "commentCount": 0,
            "registered": "2024.05.05 14:36",
            "summary": "티스토리 기본 제공 스킨 중 Poster를 사용하고 있습니다. Poster의 페이지 최하단에 뜨는 메뉴바를 블로그의 제목 아래로 바로 옮기고 싶은데, html과 css를 어떻게 조정하면 될지 조언해주실 분 계신가요? 챗 gpt한테 전체코드를 제공했음에도 문제해결이 어려웠습니다.",
            "content": "티스토리 기본 제공 스킨 중 Poster를 사용하고 있습니다. Poster의 페이지 최하단에 뜨는 메뉴바를 블로그의 제목 아래로 바로 옮기고 싶은데, html과 css를 어떻게 조정하면 될지 조언해주실 분 계신가요? 챗 gpt한테 전체코드를 제공했음에도 문제해결이 어려웠습니다.",
            "category": "스킨",
            "images": [],
            "userId": 6572636,
            "userName": "Rim_chive",
            "userDefaultUrl": "https://claireyurim.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6906749/attach/df85808226e24dd8ab5797bdb6001de6",
            "status": "normal"
        }, {
            "id": 299672,
            "title": "메인 화면 레이아웃이 갑자기 무너졌습니다.",
            "viewCount": 96,
            "commentCount": 3,
            "registered": "2024.04.30 16:48",
            "summary": "안녕하세요~ 기존에 미리보기 화면과 같은 오디세이 스킨을 적용해 쓰고 있었는데, 언제부턴가 오른쪽 이미지처럼 레이아웃이 무너진 형태로 페이지가 표출됩니다. 어떤 부분을 손대면 좋을지 알고 싶습니다.",
            "content": "안녕하세요~ \r\n기존에 미리보기 화면과 같은 오디세이 스킨을 적용해 쓰고 있었는데, 언제부턴가 오른쪽 이미지처럼 레이아웃이 무너진 형태로 페이지가 표출됩니다. 어떤 부분을 손대면 좋을지 알고 싶습니다. ",
            "category": "스킨",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/617ce777-d38f-44ae-a56d-1a7b651f3ae9",
                "size": 191107,
                "label": "20240430_131904.png"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/1f43ce68-c630-4200-9868-0330d18bee52",
                "size": 270382,
                "label": "미리보기 화면.png"
            }],
            "userId": 6397862,
            "userName": "Numbers",
            "userDefaultUrl": "https://numbersmoney.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6629420/attach/d0ee2024c6164845a41d7d256aaac853",
            "status": "normal"
        }], "hasPrev": true, "hasNext": false
    }
};
export const blogIntroData = {
    "status": 200, "desc": "OK", "data": {
        "entries": [{
            "id": 304221,
            "title": "IT 블로그 입니다. 맞구독하고 소통하며 지내요!~",
            "viewCount": 0,
            "commentCount": 0,
            "registered": "2024.06.09 17:17",
            "summary": "1일 1포스팅 하며 하루하루 성장 중인 블로그입니다. 맞구독 하고 함께 성장할 블로그 구합니다!",
            "content": "1일 1포스팅 하며 하루하루 성장 중인 블로그입니다. 맞구독 하고 함께 성장할 블로그 구합니다!",
            "category": "블로그 소개",
            "images": [],
            "userId": 3914534,
            "userName": "성준하이",
            "userDefaultUrl": "https://thenicesj.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/5040068/attach/99fcae6db9514071b6fa84285f62c828",
            "status": "normal"
        }, {
            "id": 304220,
            "title": "여러분을 초대 합니다. ",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 17:16",
            "summary": "수다 한 잔, 사진 한 장 블로그입니다. 보기만 해도 힐-링이 되는 블로그를 추구합니다. 사진과 어울린 다양한 글을 올리고 있습니다. 많이 들러 주세요.",
            "content": "수다 한 잔, 사진 한 장 블로그입니다. \r\n보기만 해도 힐-링이 되는 블로그를 추구합니다. \r\n사진과 어울린 다양한 글을 올리고 있습니다.\r\n많이 들러 주세요. ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/e47c86a8-473b-4b63-ae08-5d019409f00d",
                "size": 1055356,
                "label": "슬픈연가(1).JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/8f50dc5c-0652-49f0-97e1-0d0587141417",
                "size": 956641,
                "label": "벚꽃(해미).JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/7bd21a4c-843f-411c-bd62-fc0a5c6538ee",
                "size": 487381,
                "label": "아침이란 고독4.JPG"
            }],
            "userId": 6026884,
            "userName": "훈 작가",
            "userDefaultUrl": "https://soodaphoto.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6133358/attach/96fdfe012176466a84d79a43d4dc1cff",
            "status": "normal"
        }, {
            "id": 304219,
            "title": "그저 그런 블로그는 아닙니다.",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 17:12",
            "summary": "사진을 취미로 하면서 이런 저런 글을 포스팅 하고 있습니다. 일단 보시고 좋은 콘텐츠라고 생각 되면 많은 방문 부탁 드립니다. 구독 댓글 달아 주시면 맞구독 해드립니다. 남은 휴일도 즐겁게 보내세요.",
            "content": "사진을 취미로 하면서 이런 저런 글을 포스팅 하고 있습니다.\r\n일단 보시고 좋은 콘텐츠라고 생각 되면 많은 방문 부탁 드립니다. \r\n구독 댓글 달아 주시면 맞구독 해드립니다. \r\n남은 휴일도 즐겁게 보내세요. ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/1a825a5a-8e7a-4875-9bea-e47bae739511",
                "size": 796510,
                "label": "1.JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/28904b59-42a5-4900-8632-9df4a02e944a",
                "size": 211653,
                "label": "7.jpg"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/cff34d1c-c347-429f-9a35-b532907a5dff",
                "size": 470636,
                "label": "사진은 시다..jpg"
            }],
            "userId": 6026884,
            "userName": "훈 작가",
            "userDefaultUrl": "https://soodaphoto.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6133358/attach/96fdfe012176466a84d79a43d4dc1cff",
            "status": "normal"
        }, {
            "id": 304218,
            "title": "창작 분야 크리에이터 블로그입니다.",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 17:09",
            "summary": "사진을 소재로 다양한 글을 올리고 있습니다. 여러분과 많은 소통을 원합니다. 많은 응원 부탁 드립니다.",
            "content": "사진을 소재로 다양한 글을 올리고 있습니다.\r\n여러분과 많은 소통을 원합니다. 많은 응원 부탁 드립니다. ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/4598c9ec-aecc-4851-9add-58affe091a26",
                "size": 542617,
                "label": "뽀뽀4-4.JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/ca5d7146-ba9a-4a31-8326-7492017b8de0",
                "size": 461008,
                "label": "달구경(2).JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/2b8e6718-1603-41e2-a0f7-e1eff000f218",
                "size": 710867,
                "label": "눈꽃5.JPG"
            }],
            "userId": 6026884,
            "userName": "훈 작가",
            "userDefaultUrl": "https://soodaphoto.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6133358/attach/96fdfe012176466a84d79a43d4dc1cff",
            "status": "normal"
        }, {
            "id": 304217,
            "title": "당신의 티스토리 수익이 점점 줄어드는 이유",
            "viewCount": 2,
            "commentCount": 0,
            "registered": "2024.06.09 17:05",
            "summary": "이미지 첨부했습니다. 사실인가요?",
            "content": "이미지 첨부했습니다. 사실인가요? ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/a87fb20b-6c7e-42e8-b98a-ab1b31da8e90",
                "size": 70484,
                "label": "fwfewfewfewfewfewfwefwefewfew.jpg"
            }],
            "userId": 4756324,
            "userName": "[시론]",
            "userDefaultUrl": "https://z11neo.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4490393/attach/5d1251694f844891a68f235f9b4a9102",
            "status": "normal"
        }, {
            "id": 304216,
            "title": "^^안녕 하세요~열심히   공부 하는 블로거 에요^^",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 16:53",
            "summary": "^^ 행복한 시간 보내시구~ 응원 부탁드립니다 ^^ 하트와구독 도 부탁 드립니다^^ ^^찾아뵐테니구독 해주신다면 늘 감사하겠습니다~^^",
            "content": "^^ 행복한  시간 보내시구~~ 응원 부탁드립니다~\r\n^^ 하트와구독 도 부탁 드립니다~^^\r\n^^찾아뵐테니~구독 해주신다면 늘 감사하겠습니다~^^",
            "category": "블로그 소개",
            "images": [],
            "userId": 6510021,
            "userName": "머니머니헤어",
            "userDefaultUrl": "https://moneyheair.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6799023/attach/126602fcb6a54ce2b98d3c0d7ce0c6e6",
            "status": "normal"
        }, {
            "id": 304215,
            "title": "^^안녕 하세요~열심히   공부 하는 블로거 에요^^",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 16:53",
            "summary": "^^ 행복한 시간 보내시구~ 응원 부탁드립니다 ^^ 하트와구독 도 부탁 드립니다^^ ^^찾아뵐테니구독 해주신다면 늘 감사하겠습니다~^^",
            "content": "^^ 행복한  시간 보내시구~~ 응원 부탁드립니다~\r\n^^ 하트와구독 도 부탁 드립니다~^^\r\n^^찾아뵐테니~구독 해주신다면 늘 감사하겠습니다~^^",
            "category": "블로그 소개",
            "images": [],
            "userId": 6510021,
            "userName": "머니머니헤어",
            "userDefaultUrl": "https://moneyheair.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6799023/attach/126602fcb6a54ce2b98d3c0d7ce0c6e6",
            "status": "normal"
        }, {
            "id": 304214,
            "title": "^^안녕 하세요~열심히   공부 하는 블로거 에요^^",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 16:53",
            "summary": "^^ 행복한 시간 보내시구~ 응원 부탁드립니다 ^^ 하트와구독 도 부탁 드립니다^^ ^^찾아뵐테니구독 해주신다면 늘 감사하겠습니다~^^",
            "content": "^^ 행복한  시간 보내시구~~ 응원 부탁드립니다~\r\n^^ 하트와구독 도 부탁 드립니다~^^\r\n^^찾아뵐테니~구독 해주신다면 늘 감사하겠습니다~^^",
            "category": "블로그 소개",
            "images": [],
            "userId": 6510021,
            "userName": "머니머니헤어",
            "userDefaultUrl": "https://moneyheair.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6799023/attach/126602fcb6a54ce2b98d3c0d7ce0c6e6",
            "status": "normal"
        }, {
            "id": 304213,
            "title": "인생을 바꿔 드립니다",
            "viewCount": 3,
            "commentCount": 0,
            "registered": "2024.06.09 16:28",
            "summary": "안녕하세요! 살아가면서 인생에 도움 되는 정보들을 모아 놨습니다. 맞구독 신청하시면 바로 승인해드리니 부담 없이 방문 하셔서 구독 신청해주세요. 감사합니다~^ https://taurine77.tistory.com",
            "content": "안녕하세요! 살아가면서 인생에 도움 되는 정보들을 모아 놨습니다.\r\n맞구독 신청하시면 바로 승인해드리니 부담 없이 방문 하셔서 구독 신청해주세요. 감사합니다~^\r\nhttps://taurine77.tistory.com",
            "category": "블로그 소개",
            "images": [],
            "userId": 5545522,
            "userName": "숏힐링(Short Healing)",
            "userDefaultUrl": "https://taurine77.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/5581697/attach/bd3621800f28456f8807b54feb8e1ba7",
            "status": "normal"
        }, {
            "id": 304212,
            "title": "꼬꼬무 축제",
            "viewCount": 2,
            "commentCount": 0,
            "registered": "2024.06.09 16:19",
            "summary": ".",
            "content": ".",
            "category": "블로그 소개",
            "images": [],
            "userId": 6206639,
            "userName": "조각몸매 이휴재",
            "userDefaultUrl": "https://ad2072nn.tistory.com",
            "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
            "status": "normal"
        }], "hasPrev": true, "hasNext": false
    }
};
export const blogEntryData = {
    "status": 200, "desc": "OK", "data": {
        "entries": [{
            "id": 304223,
            "title": "안녕하세요! 평범한 공대생의 블로그입니다!",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 17:38",
            "summary": "다들 맞구독해요!",
            "content": "다들 맞구독해요!",
            "category": "블로그 소개",
            "images": [],
            "userId": 4369386,
            "userName": "AGAPE1225",
            "userDefaultUrl": "https://apape1225.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/3890383/attach/ea1a3826af3a4eef9f68b8ccd8712cee",
            "status": "normal"
        }, {
            "id": 304222,
            "title": "4세대 실손의료보험료 할인할증 내용확인!! (7.1일)",
            "viewCount": 2,
            "commentCount": 0,
            "registered": "2024.06.09 17:34",
            "summary": "https://sunnypark7788.tistory.com/61 4세대 실손의료보험료 할인.할증제도가 7.1일부터 본격시행되는군요. 실비 전환이 유리한지 자신들의 의료사용 행태를 살펴보면 유불리가 있을 것 같습니다. 무엇보다도 건강하시고요~!!",
            "content": "https://sunnypark7788.tistory.com/61\r\n\r\n4세대 실손의료보험료 할인.할증제도가 7.1일부터 본격시행되는군요. 실비 전환이 유리한지 자신들의 의료사용 행태를 살펴보면 유불리가 있을 것 같습니다. 무엇보다도 건강하시고요~!!",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/335d5697-3680-41b1-ac0e-0fa06a74a011",
                "size": 37632,
                "label": "rescue-7074654_640.png"
            }],
            "userId": 6664719,
            "userName": "썸띵 디퍼런트",
            "userDefaultUrl": "https://sunnypark7788.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/7055921/attach/41c50a8d5fa644f4b868e86f9877351e",
            "status": "normal"
        }, {
            "id": 304221,
            "title": "IT 블로그 입니다. 맞구독하고 소통하며 지내요!~",
            "viewCount": 0,
            "commentCount": 0,
            "registered": "2024.06.09 17:17",
            "summary": "1일 1포스팅 하며 하루하루 성장 중인 블로그입니다. 맞구독 하고 함께 성장할 블로그 구합니다!",
            "content": "1일 1포스팅 하며 하루하루 성장 중인 블로그입니다. 맞구독 하고 함께 성장할 블로그 구합니다!",
            "category": "블로그 소개",
            "images": [],
            "userId": 3914534,
            "userName": "성준하이",
            "userDefaultUrl": "https://thenicesj.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/5040068/attach/99fcae6db9514071b6fa84285f62c828",
            "status": "normal"
        }, {
            "id": 304220,
            "title": "여러분을 초대 합니다. ",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 17:16",
            "summary": "수다 한 잔, 사진 한 장 블로그입니다. 보기만 해도 힐-링이 되는 블로그를 추구합니다. 사진과 어울린 다양한 글을 올리고 있습니다. 많이 들러 주세요.",
            "content": "수다 한 잔, 사진 한 장 블로그입니다. \r\n보기만 해도 힐-링이 되는 블로그를 추구합니다. \r\n사진과 어울린 다양한 글을 올리고 있습니다.\r\n많이 들러 주세요. ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/e47c86a8-473b-4b63-ae08-5d019409f00d",
                "size": 1055356,
                "label": "슬픈연가(1).JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/8f50dc5c-0652-49f0-97e1-0d0587141417",
                "size": 956641,
                "label": "벚꽃(해미).JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/7bd21a4c-843f-411c-bd62-fc0a5c6538ee",
                "size": 487381,
                "label": "아침이란 고독4.JPG"
            }],
            "userId": 6026884,
            "userName": "훈 작가",
            "userDefaultUrl": "https://soodaphoto.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6133358/attach/96fdfe012176466a84d79a43d4dc1cff",
            "status": "normal"
        }, {
            "id": 304219,
            "title": "그저 그런 블로그는 아닙니다.",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 17:12",
            "summary": "사진을 취미로 하면서 이런 저런 글을 포스팅 하고 있습니다. 일단 보시고 좋은 콘텐츠라고 생각 되면 많은 방문 부탁 드립니다. 구독 댓글 달아 주시면 맞구독 해드립니다. 남은 휴일도 즐겁게 보내세요.",
            "content": "사진을 취미로 하면서 이런 저런 글을 포스팅 하고 있습니다.\r\n일단 보시고 좋은 콘텐츠라고 생각 되면 많은 방문 부탁 드립니다. \r\n구독 댓글 달아 주시면 맞구독 해드립니다. \r\n남은 휴일도 즐겁게 보내세요. ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/1a825a5a-8e7a-4875-9bea-e47bae739511",
                "size": 796510,
                "label": "1.JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/28904b59-42a5-4900-8632-9df4a02e944a",
                "size": 211653,
                "label": "7.jpg"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/cff34d1c-c347-429f-9a35-b532907a5dff",
                "size": 470636,
                "label": "사진은 시다..jpg"
            }],
            "userId": 6026884,
            "userName": "훈 작가",
            "userDefaultUrl": "https://soodaphoto.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6133358/attach/96fdfe012176466a84d79a43d4dc1cff",
            "status": "normal"
        }, {
            "id": 304218,
            "title": "창작 분야 크리에이터 블로그입니다.",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 17:09",
            "summary": "사진을 소재로 다양한 글을 올리고 있습니다. 여러분과 많은 소통을 원합니다. 많은 응원 부탁 드립니다.",
            "content": "사진을 소재로 다양한 글을 올리고 있습니다.\r\n여러분과 많은 소통을 원합니다. 많은 응원 부탁 드립니다. ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/4598c9ec-aecc-4851-9add-58affe091a26",
                "size": 542617,
                "label": "뽀뽀4-4.JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/ca5d7146-ba9a-4a31-8326-7492017b8de0",
                "size": 461008,
                "label": "달구경(2).JPG"
            }, {
                "url": "https://tistory1.daumcdn.net/tistory/forum/2b8e6718-1603-41e2-a0f7-e1eff000f218",
                "size": 710867,
                "label": "눈꽃5.JPG"
            }],
            "userId": 6026884,
            "userName": "훈 작가",
            "userDefaultUrl": "https://soodaphoto.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6133358/attach/96fdfe012176466a84d79a43d4dc1cff",
            "status": "normal"
        }, {
            "id": 304217,
            "title": "당신의 티스토리 수익이 점점 줄어드는 이유",
            "viewCount": 4,
            "commentCount": 0,
            "registered": "2024.06.09 17:05",
            "summary": "이미지 첨부했습니다. 사실인가요?",
            "content": "이미지 첨부했습니다. 사실인가요? ",
            "category": "블로그 소개",
            "images": [{
                "url": "https://tistory1.daumcdn.net/tistory/forum/a87fb20b-6c7e-42e8-b98a-ab1b31da8e90",
                "size": 70484,
                "label": "fwfewfewfewfewfewfwefwefewfew.jpg"
            }],
            "userId": 4756324,
            "userName": "[시론]",
            "userDefaultUrl": "https://z11neo.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4490393/attach/5d1251694f844891a68f235f9b4a9102",
            "status": "normal"
        }, {
            "id": 304216,
            "title": "^^안녕 하세요~열심히   공부 하는 블로거 에요^^",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 16:53",
            "summary": "^^ 행복한 시간 보내시구~ 응원 부탁드립니다 ^^ 하트와구독 도 부탁 드립니다^^ ^^찾아뵐테니구독 해주신다면 늘 감사하겠습니다~^^",
            "content": "^^ 행복한  시간 보내시구~~ 응원 부탁드립니다~\r\n^^ 하트와구독 도 부탁 드립니다~^^\r\n^^찾아뵐테니~구독 해주신다면 늘 감사하겠습니다~^^",
            "category": "블로그 소개",
            "images": [],
            "userId": 6510021,
            "userName": "머니머니헤어",
            "userDefaultUrl": "https://moneyheair.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6799023/attach/126602fcb6a54ce2b98d3c0d7ce0c6e6",
            "status": "normal"
        }, {
            "id": 304215,
            "title": "^^안녕 하세요~열심히   공부 하는 블로거 에요^^",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 16:53",
            "summary": "^^ 행복한 시간 보내시구~ 응원 부탁드립니다 ^^ 하트와구독 도 부탁 드립니다^^ ^^찾아뵐테니구독 해주신다면 늘 감사하겠습니다~^^",
            "content": "^^ 행복한  시간 보내시구~~ 응원 부탁드립니다~\r\n^^ 하트와구독 도 부탁 드립니다~^^\r\n^^찾아뵐테니~구독 해주신다면 늘 감사하겠습니다~^^",
            "category": "블로그 소개",
            "images": [],
            "userId": 6510021,
            "userName": "머니머니헤어",
            "userDefaultUrl": "https://moneyheair.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6799023/attach/126602fcb6a54ce2b98d3c0d7ce0c6e6",
            "status": "normal"
        }, {
            "id": 304214,
            "title": "^^안녕 하세요~열심히   공부 하는 블로거 에요^^",
            "viewCount": 1,
            "commentCount": 0,
            "registered": "2024.06.09 16:53",
            "summary": "^^ 행복한 시간 보내시구~ 응원 부탁드립니다 ^^ 하트와구독 도 부탁 드립니다^^ ^^찾아뵐테니구독 해주신다면 늘 감사하겠습니다~^^",
            "content": "^^ 행복한  시간 보내시구~~ 응원 부탁드립니다~\r\n^^ 하트와구독 도 부탁 드립니다~^^\r\n^^찾아뵐테니~구독 해주신다면 늘 감사하겠습니다~^^",
            "category": "블로그 소개",
            "images": [],
            "userId": 6510021,
            "userName": "머니머니헤어",
            "userDefaultUrl": "https://moneyheair.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/6799023/attach/126602fcb6a54ce2b98d3c0d7ce0c6e6",
            "status": "normal"
        }], "hasPrev": true, "hasNext": false
    }
};
export const blogTipDetailData = {
    "status": 200, "desc": "OK", "data": {
        "comments": [{
            "entryId": 304124,
            "id": 218652,
            "registered": "2024.06.08 17:16",
            "content": "안녕하세요! 맞구독 신청해요~",
            "status": null,
            "userId": 5545522,
            "userName": "숏힐링(Short Healing)",
            "userDefaultUrl": "https://taurine77.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/5581697/attach/bd3621800f28456f8807b54feb8e1ba7"
        }, {
            "entryId": 304124,
            "id": 218685,
            "registered": "2024.06.09 09:10",
            "content": "똑같은 글 복사 붙이기 하는 것도 능력",
            "status": null,
            "userId": 86533,
            "userName": "티스토리탈출",
            "userDefaultUrl": "https://exit-out.tistory.com",
            "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png"
        }, {
            "entryId": 304124,
            "id": 218687,
            "registered": "2024.06.09 09:21",
            "content": "ㄴ 안녕하세요 ㅆㄷㄱ님! 굳이 또 세컨 계정으로 댓글을 남겨주시네요 ㅎㅎ 논리도 없고 팩트는 부정하고 싶은 ㅆㄷㄱ님이 남은 건 딴지걸기? 이 어려운 시기 꼭 잘 이겨내셔서 정년 넘도록 잘 운영하시길 진심으로 기원합니다. 권력이 영원하셨으면 좋겠네요 ",
            "status": null,
            "userId": 1185164,
            "userName": "브랜던의 지식공장",
            "userDefaultUrl": "https://infiniteinformation.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2824660/attach/44523e9670224dafb46a227283f083fd"
        }, {
            "entryId": 304124,
            "id": 218688,
            "registered": "2024.06.09 09:44",
            "content": "ㅋㅋㅋㅋ 망상도 자유죠. 아무튼 재미있게 혼자 흥분해서 잘 노시네요. 그 분노 블로그 운영하는데나 잘 쓰세요. ",
            "status": null,
            "userId": 86533,
            "userName": "티스토리탈출",
            "userDefaultUrl": "https://exit-out.tistory.com",
            "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png"
        }, {
            "entryId": 304124,
            "id": 218701,
            "registered": "2024.06.09 15:34",
            "content": "안녕하세요 맞구독 신청합니다!",
            "status": null,
            "userId": 6706535,
            "userName": "btcgraduation",
            "userDefaultUrl": "https://btcgraduation.tistory.com",
            "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png"
        }, {
            "entryId": 304124,
            "id": 218707,
            "registered": "2024.06.09 16:42",
            "content": "ㅎㅎ사실 에너지를 써가며 그렇게 면박 줄만큼 뭐라할만큼 반박하고 싶지는 않았는데 그래도 그닥 보고싶지 않은 글들이 있어서 그닥 좋지 않았는데 다른 사람이 대신하네요. \n투정이 섞인 분석글은 자신의 블로그에 하심이 좋을 듯합니다.\n면박이나 조롱은 아니고 그저 권고일 뿐이에요",
            "status": null,
            "userId": 3780467,
            "userName": "Esther♡",
            "userDefaultUrl": "https://lovelyesther.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2959036/attach/b87d2504ef15489688281e67cc87cc3c"
        }, {
            "entryId": 304124,
            "id": 218708,
            "registered": "2024.06.09 16:51",
            "content": "ㄴ 투정한 적 없는데요?? 죄송하지만 제가 블로그를 열심히 하는게 아니라서요 ㅎㅎ 외부 상황 상관 없이 글 쓰는게 좋으신 에스더님에게는 그닥 불필요한 정보일 거 같구요 제가 님 블로그 어찌되든 상관할 바 아니니 하시던 것 열심히 하시면 됩니다. \n\n외부상황이 안 좋을 수록 돈만 보고온 유저가 이탈하니 순수하게 본연의 블러깅 하시는 에스더님이 더 좋지 않을까요? 면박이나 조롱은 아니고 그저 권고사항일 뿐입니다. \n\n그리고 ㅆㄷㄱ님은 별다른 논리도 없이 세컨아이디에 숨어 저러고 계십니다. 요즘 상황이 상황인지라 스트레스가 많으신 것 같네요 ㅎㅎ 응원부탁드립니다 ",
            "status": null,
            "userId": 1185164,
            "userName": "브랜던의 지식공장",
            "userDefaultUrl": "https://infiniteinformation.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/2824660/attach/44523e9670224dafb46a227283f083fd"
        }, {
            "entryId": 304124,
            "id": 218720,
            "registered": "2024.06.09 17:44",
            "content": "좋은 정보 감사합니다. ",
            "status": null,
            "userId": 4756324,
            "userName": "[시론]",
            "userDefaultUrl": "https://z11neo.tistory.com",
            "userImage": "https://tistory1.daumcdn.net/tistory/4490393/attach/5d1251694f844891a68f235f9b4a9102"
        }]
    }
};
